import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getTenantSettingsEndpoint } from 'repositories/BerthApi/getTenantSettings/endpoint'
import type { GetTenantSettingsResponse } from 'repositories/BerthApi/getTenantSettings/type'
import { tenantKeys } from 'repositories/queryKeys'

export function useTenantSetting(tenantId: string | null) {
  const key = tenantId ? getTenantSettingsEndpoint(tenantId) : null

  const { data, error, isLoading } = useQuery<GetTenantSettingsResponse>({
    queryKey: tenantKeys.settingsByTenant(tenantId ?? ''),
    queryFn: () => fetcher(key!),
    enabled: !!key,
  })

  return {
    canSpBerthManagement: data?.data?.canSpBerthManagement ?? false,
    canUnmannedCheckin: data?.data?.canUnmannedCheckin ?? false,
    isLoading,
    error,
  }
}
